import { authSlice } from "./authSlice";
import { requestLoginUser, requestMe, requestLogout, requestUpdateProfile, requestCode, requestAccceptAgreement } from "./authCrud";
import { httpSlice } from "../../Http/_redux/httpSlice";
import { handleError } from '../../../app/Utils'
import { toast } from "react-toastify";

const { actions } = authSlice;
const httpAction = httpSlice.actions;

export const loginUser = (body, page = 'LOGIN_USER') => (dispatch) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestLoginUser(body)
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setUser(data))
      toast.success("شما با موفقیت وارد شدید!", { autoClose: 5000 })
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
};

export const acceptAgreement = (page = 'ACCEPT_AGREEMENT') => (dispatch) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestAccceptAgreement()
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setUser(data))
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
};

//Login whith user/pass
/* export const loginUser = (body, page = 'LOGIN_USER') => (dispatch) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestLoginUser(body)
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setUser(data))
      toast.success("شما با موفقیت وارد شدید!", { autoClose: 5000 })
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
}; */

export const getCode = (body, page = 'REQUEST_CODE') => (dispatch) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestCode(body)
    .then(({ data }) => {
      //localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setCellphone(body.cellphone))
      toast.success("کد برای شما ارسال شد!", { autoClose: 5000 })
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
};


export const checkLogin = (page = 'CHECK_LOGIN') => (dispatch, getState) => {
  const { auth } = getState()
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestMe()
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setUser(data))
      if (!auth?.user?.user && !window.location.pathname.includes('/video'))
        toast.success("شما وارد سایت شده اید!", { autoClose: 5000 })
    })
    .catch((error) => {
      if (error?.response?.status === 401) {
        localStorage.removeItem('access_token')
        dispatch(actions.setUser({
          access_token: null
        }))
      }
      const regex = /\/blogs\/.*/gm;

      handleError(dispatch, error, httpAction.setError, page, ['/', '/contact', '/catalogs', '/blogs'].includes(window.location.pathname) || regex.test(window.location.pathname))
    })
};


export const logoutUser = (page = 'LOGOUT_USER') => (dispatch, { auth }) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestLogout()
    .then(() => {
      dispatch(httpAction.setOk(page))
      localStorage.removeItem('access_token')
      dispatch(actions.setUser({
        access_token: null
      }))
      toast.success("شما از سایت خارج شده اید!", { autoClose: 5000 })
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
}


export const updateProfile = (body, page = 'PROFILE') => (dispatch, { auth }) => {
  dispatch(httpAction.setLoader({ loader: true, page }));
  return requestUpdateProfile(body)
    .then(({ data }) => {
      localStorage.setItem('access_token', data.access_token)
      dispatch(httpAction.setOk(page))
      dispatch(actions.setUser(data))
      if (!auth?.user?.user)
        toast.success("اطلاعات با موفقیت بروز شد!", { autoClose: 5000 })
    })
    .catch((error) => {
      handleError(dispatch, error, httpAction.setError, page)
    })
};